import {useCallback, useState} from 'react';

export const useGroupSelectedItems = <T>() => {
    const [selectedItems, setSelectedItems] = useState<T[]>([]);

    const handleGroupActionSelectItems = useCallback((items: T[]) => {
        setSelectedItems(items);
    }, []);

    return {
        selectedItems,
        setSelectedItems,
        handleGroupActionSelectItems
    };
};